function importAll(r) {
  return r.keys().map(r)
}

const actionAvatarImages = importAll(
  require.context('../../images/avatars/action', false, /\.(png|jpe?g|svg)$/)
)
const peopleMaleAvatarImages = importAll(
  require.context('../../images/avatars/people/male', false, /\.(png|jpe?g|svg)$/)
)
const peopleFemaleAvatarImages = importAll(
  require.context('../../images/avatars/people/female', false, /\.(png|jpe?g|svg)$/)
)

interface AvatarIcon {
  url: {
    default: string
  }
  alt: string
}

let actionAvatars: AvatarIcon[] = []
let peopleMaleAvatars: AvatarIcon[] = []
let peopleFemaleAvatars: AvatarIcon[] = []

actionAvatarImages.forEach((image, i) => {
  actionAvatars.push({ url: image, alt: `action avatar ${i + 1}` })
})

peopleMaleAvatarImages.forEach((image, i) => {
  peopleMaleAvatars.push({ url: image, alt: `people male avatar ${i + 1}` })
})

peopleFemaleAvatarImages.forEach((image, i) => {
  peopleFemaleAvatars.push({ url: image, alt: `people female avatar ${i + 1}` })
})

const avatars = { actionAvatars, peopleMaleAvatars, peopleFemaleAvatars }

export default avatars
